import request from '../setup/request';

const map = {
  /**
   * 获取导览列表
   */
  getGuidelist(params) {
    return request.post('', {
      ...params,
      method: 'ih.cms.guide.getlist',
    });
  },
};

export default map;
